import { FormField, FormItem, FormLabel, FormControl, FormMessage } from '../ui/form';
import { Select as MuiSelect, MenuItem, FormControl as MuiFormControl } from '@mui/material';
import { Control } from 'react-hook-form';

interface PageSizeSelectorProps {
  control: Control<any>;
  name: string;
  label?: string;
  options?: { value: string; label: string }[];
}

const defaultOptions = [
  { value: "10", label: "10 per page" },
  { value: "25", label: "25 per page" },
  { value: "50", label: "50 per page" },
  { value: "100", label: "100 per page" },
//   { value: "0", label: "Show All" }
];

function PageSizeSelector({ 
  control, 
  name, 
  label = "Items per Page",
  options = defaultOptions 
}: PageSizeSelectorProps) {
  return (
    <FormField
      control={control}
      name={name}
      render={({ field }) => (
        <FormItem>
          <FormLabel className="text-sm font-medium text-gray-700 dark:text-gray-300">
            {label}
          </FormLabel>
          <FormControl>
            <MuiFormControl fullWidth size="small">
              <MuiSelect
                value={field.value?.toString() || "10"}
                onChange={(e) => {
                  const value = e.target.value;
                  const numValue = value === "0" ? 0 : parseInt(value);
                  field.onChange(numValue);
                }}
                displayEmpty
                sx={{
                  height: '44px',
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: 'divider',
                  },
                  '&:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: 'primary.main',
                  },
                  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                    borderColor: 'primary.main',
                    borderWidth: '2px',
                  },
                }}
              >
                {options.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </MuiSelect>
            </MuiFormControl>
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}

export default PageSizeSelector;